export const name = "FORMAT_TIMESTAMP";
export const summary = `Formats a \`TIMESTAMP\` value according to the specified format string.`;
export const reference = `
## FORMAT_TIMESTAMP

Formats a \`TIMESTAMP\` value according to the specified format string.

\`\`\`
FORMAT_TIMESTAMP(format_string, timestamp_expr[, time_zone])
\`\`\`

### Description

Formats a \`TIMESTAMP\` value according to the specified format string.


### Definitions

- \`format_string\`: A \`STRING\` value that contains the format elements to use with\`timestamp_expr\`.
- \`timestamp_expr\`: A \`TIMESTAMP\` value that represents the timestamp to format.
- \`time_zone\`: A \`STRING\` value that represents a time zone. For more information about how to use a time zone with a timestamp, see Time zone definitions.


### Return Data Type

\`STRING\`


### Examples



\`\`\`
SELECT FORMAT_TIMESTAMP("%c", TIMESTAMP "2050-12-25 15:30:55+00", "UTC")
  AS formatted;

/*--------------------------*
 | formatted |
 +--------------------------+
 | Sun Dec 25 15:30:55 2050 |
 *--------------------------*/
\`\`\`



\`\`\`
SELECT FORMAT_TIMESTAMP("%b-%d-%Y", TIMESTAMP "2050-12-25 15:30:55+00")
  AS formatted;

/*-------------*
 | formatted |
 +-------------+
 | Dec-25-2050 |
 *-------------*/
\`\`\`



\`\`\`
SELECT FORMAT_TIMESTAMP("%b %Y", TIMESTAMP "2050-12-25 15:30:55+00")
  AS formatted;

/*-------------*
 | formatted |
 +-------------+
 | Dec 2050 |
 *-------------*/
\`\`\`



\`\`\`
SELECT FORMAT_TIMESTAMP("%Y-%m-%dT%H:%M:%SZ", TIMESTAMP "2050-12-25 15:30:55", "UTC")
  AS formatted;

/*+---------------------*
 | formatted |
 +----------------------+
 | 2050-12-25T15:30:55Z |
 *----------------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/timestamp_functions
`;
